import React, {useState, useRef} from 'react';
import b_ from 'b_';

import {Popup} from 'client/common/components/lego';
import IconButton from 'client/common/components/icon-button';
import LoaderPopup from 'client/creatives/components/creative-loader/creative-loader-popup';

import I18N from 'assets/i18n/brandlift-project';

import {CreativeCreateData} from 'client/creatives/types';

import './creative-card.css';

const i18n = I18N.creatives.creativeCard;
const b = b_.with('creative-card');

function ReplaceContent() {
    return (
        <div className={b('replace-content')}>
            <h3>{i18n.replaceVideo.title}</h3>
            <p>{i18n.replaceVideo.description}</p>
        </div>
    );
}

export interface ReplaceButtonProps {
    onReplace: (creative: CreativeCreateData) => Promise<void>;
}

export default function ReplaceButton(props: ReplaceButtonProps) {
    const {onReplace} = props;

    const buttonRef = useRef(null);
    const bodyRef = useRef(document.body);

    const [isPopupVisible, setIsPopupVisible] = useState(false);

    async function handleSubmitReplace({creatives}: {creatives: CreativeCreateData[]}) {
        if (!creatives.length) {
            return;
        }

        await onReplace(creatives[0]);
    }

    return (
        <>
            <IconButton
                innerRef={buttonRef}
                className={b('button', {type: 'replace'})}
                tooltipClassname={b('replace-popup')}
                content={<ReplaceContent />}
                type='refresh'
                tooltipDirection='bottom-start'
                mainOffset={16}
                boundary={bodyRef}
                trigger={['hover', 'click']}
                onClick={() => setIsPopupVisible(old => !old)}
            />
            <Popup
                view='default'
                target='anchor'
                direction='right-start'
                mainOffset={30}
                secondaryOffset={-5}
                visible={isPopupVisible}
                anchor={buttonRef}
                boundary={bodyRef}
                // Чтобы показываться под попапом с подсказкой из компонента выше
                zIndex={1000}
                onClose={() => setIsPopupVisible(false)}
            >
                <LoaderPopup onSubmit={handleSubmitReplace} submitText={i18n.replaceVideo.submit} />
            </Popup>
        </>
    );
}
